import { withStyles } from '@material-ui/core'
import Dot from './Dot'
import Line from './Line'
import { STAGES_COLORS } from './Stepper'
import { EVENT_STATUSES } from 'components/Tables/Events'

const Stage = ({ classes, stage, stageStatus, isSuccess }) => {
  const colorDot =
    stageStatus === 'progress' && isSuccess === null
      ? STAGES_COLORS.PROGRESS
      : isSuccess === true
      ? STAGES_COLORS.SUCCESS
      : STAGES_COLORS.FAILED

  const lineColor =
    stageStatus === 'progress' && isSuccess === null
      ? STAGES_COLORS.PROGRESS
      : isSuccess === true
      ? STAGES_COLORS.SUCCESS
      : STAGES_COLORS.PROGRESS

  return (
    <>
      {stage !== EVENT_STATUSES.created.toString() && (
        <span className={classes.item}>
          <Line left={false} color={lineColor} />
        </span>
      )}
      <span className={classes.item}>
        <Dot color={colorDot} />
      </span>
      {stage !== EVENT_STATUSES.rate.toString() &&
        stage !== EVENT_STATUSES.cancelled.toString() && (
          <span className={classes.item}>
            <Line left color={lineColor} />
          </span>
        )}
    </>
  )
}

const styles = () => ({
  wrapper: {
    textAlign: 'center',
    lineHeight: 0,
    fontSize: 0
  },
  item: {
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: 0
  }
})

export default withStyles(styles)(Stage)
